export enum Entity {
  algorithm = 'algorithm',
  pricingProgram = 'pricingProgram',
  pricingSignal = 'pricingSignal',
  notifications = 'notifications',
  planType = 'planType'
}
